/**
 * Created by forbiz on 2020-03-29.
 */

import Swiper from 'swiper/dist/js/swiper'

const marketList = () => {

    const marketSubmenu = () => {
        const $target = $('.submenu .swiper-container');
        var totalWidth = 0;

        $('.submenu .submenu__list').each(function(){
            totalWidth = totalWidth + $(this).outerWidth();
        });

        if( totalWidth >= '1100' ){
            $target.append("<div class='swiper-button-next'></div>\n<div class='swiper-button-prev'></div>");

            const $slider = new Swiper($target, {
                slidesPerView: 'auto',
                grabCursor: true,
                paginationClickable: true,
                navigation: { 
                    nextEl: '.swiper-button-next', 
                    prevEl: '.swiper-button-prev', 
                }
            });

            const sliderIdx = $('.submenu .swiper-container .submenu__list--on').index();
            $slider.slideTo(sliderIdx-1, 0);
        }
    };

    const marketSubmenu2 = () => {
        const $target = $('.submenu2 .swiper-container');
        var totalWidth = 0;

        $('.submenu2 .swiper-container .swiper-slide').each(function(){
            totalWidth = totalWidth + $(this).outerWidth();
        });

        if( totalWidth >= '1100' ){

            const $slider = new Swiper($target, {
                slidesPerView: 'auto',
                grabCursor: true
            });

            const sliderIdx = $('.submenu2 .swiper-container .swiper-slide.on').index();
            $slider.slideTo(sliderIdx-1, 0);
        }
    };

    const marketBrandBanner = () => {
        const $target = $('.brand-banner');

        if ($target.find('.brand-banner__slide').length > 1) {
            hdFn.hdSlide($target, {
                fade: true,
                infinite: true,
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 4000,
                arrows: true,
                dots: true,
                speed: 300
            });
        }
    }

    const marketList_init = () => {
    };

    marketList_init();

    window.marketSubmenu = marketSubmenu;
    window.marketSubmenu2 = marketSubmenu2;
    window.marketBrandBanner = marketBrandBanner;
};

export default marketList;